/* eslint-disable no-unused-vars */
export enum ECurrency {
    MXN = 'MXN',
    USD = 'USD',
    COP = 'COP',
    PEN = 'PEN',
    ARS = 'ARS',
    UYU = 'UYU',
    CRC = 'CRC',
}
